import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const deleteJobLabour = async ({ serviceId, labourId }: JsonDataItem) => {
  const { data } = await baseQuery(`job-labour/${serviceId}/${labourId}`, {
    type: 'DELETE',
  });

  return data;
};
